// @ts-nocheck

import React from 'react';
import { useAtomValue } from 'jotai';

import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import styles from '../styles/Footer.module.css';
import { useThemeContext, useWideLayout } from '@shared/hooks';
import { isWhiteTheme } from '@shared/utils';
import { MoreAboutTheCompany } from '@shared/ui/more-about-the-company';
import { AboutUs } from '@shared/ui/about-us';
import { VipFeatures } from '@shared/ui/vip-features';
import { FollowUs } from '@shared/ui/follow-us';
import Icons from '@shared/config/constants/Icons';
import { dcbAtom, languageAtom } from '@shared/store/slice-atoms';
import { isID } from '@entities/country';

const Footer = ({
  hideFeatures = false,
  activationURL = null,
  isOTP = false,
  isVoucher = false,
  vipFeaturesConfig,
  followUsConfig,
  moreAboutUsConfig,
  aboutUsConfig,
}) => {
  const { t } = useTranslation();
  const { theme } = useThemeContext();
  const isWhite = isWhiteTheme(theme);
  const { otpError, homeData } = useAtomValue(dcbAtom);
  const language = useAtomValue(languageAtom);

  const { isTVLayout } = useWideLayout();

  // NOTE: Hide App Store / Google Play badges for Indonesia
  const hideStoreLinks = isID(homeData?.country) || language?.locale === 'id';

  if (isTVLayout) return null;

  const isTabIndexDisabled = localStorage.getItem('isTabIndexDisabled') === 'true';
  const tabIndex = isTabIndexDisabled ? -1 : undefined;

  return (
    <>
      {!hideFeatures && (
        <section className="features-section">
          {isOTP && !otpError && <div className={styles.otpMargin} />}

          {isOTP && otpError && !hideStoreLinks && (
            <>
              <Row className="mt-2 ">
                <Col>
                  <p className="section-title-1 fs-14">{t('download_for_free')}</p>
                </Col>
              </Row>

              <Row className="mt-2 mb-4">
                <Col>
                  <div className="text-center">
                    <a
                      href="https://apps.apple.com/us/app/360-vuz-live-vr-video-views/id964118383"
                      tabIndex={tabIndex}
                    >
                      <img
                        src={isWhite ? Icons.appleStoreWhite : Icons.appleStore}
                        className="img-fluid"
                        alt="Download App from App Store"
                      />
                    </a>
                  </div>
                </Col>
                <Col>
                  <div className="text-center">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.creativeinnovations.mea&hl=en"
                      tabIndex={tabIndex}
                    >
                      <img
                        src={isWhite ? Icons.playStoreWhite : Icons.playStore}
                        className="img-fluid"
                        alt="Download App from Play Store"
                      />
                    </a>
                  </div>
                </Col>
              </Row>
            </>
          )}

          <VipFeatures vipFeaturesConfig={vipFeaturesConfig} />
        </section>
      )}

      {!isOTP && !hideStoreLinks && (
        <>
          <Row className="mt-2">
            <Col>
              <p className="section-title-1 fs-14">{t('download_for_free')}</p>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col>
              <div className="text-center">
                <a
                  tabIndex={tabIndex}
                  href={
                    activationURL
                      ? activationURL
                      : 'https://apps.apple.com/us/app/360-vuz-live-vr-video-views/id964118383'
                  }
                >
                  <img
                    src={isWhite ? Icons.appleStoreWhite : Icons.appleStore}
                    className="img-fluid"
                    alt="Download App from App Store"
                  />
                </a>
              </div>
            </Col>
            <Col>
              <div className="text-center">
                <a
                  tabIndex={tabIndex}
                  href={
                    activationURL
                      ? activationURL
                      : 'https://play.google.com/store/apps/details?id=com.creativeinnovations.mea&hl=en'
                  }
                >
                  <img
                    src={isWhite ? Icons.playStoreWhite : Icons.playStore}
                    className="img-fluid"
                    alt="Download App from Play Store"
                  />
                </a>
              </div>
            </Col>
          </Row>
        </>
      )}

      {isVoucher && <div className="mtt-100" />}

      <FollowUs followUsConfig={followUsConfig} tabIndex={tabIndex} />
      <MoreAboutTheCompany tabIndex={tabIndex} moreAboutUsConfig={moreAboutUsConfig} />
      <AboutUs tabIndex={tabIndex} aboutUsConfig={aboutUsConfig} />
    </>
  );
};

export { Footer };
